import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { ICategory } from '../interfaces/category.interface';

export class CategoryModel extends BaseModel implements ICategory {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  source!: string;

  @Expose()
  isActive!: boolean;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  categoryRole!: string;

  @Expose()
  categoryType!: string;

}
